import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/industries/new/loading';

export const Route = createFileRoute('/_private/settings/industries/new')({
  component: Loading,
});
